export default {"src":"/_next/static/media/php_logo_60399407da.b5452288.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};